<template>
  <layout-view navTitle="Фильтры">
    <template v-slot:nav>
      <div class="px-4">
        <date-interval name="Дата создания" :valueFrom.sync="filter.dateFrom" :valueTo.sync="filter.dateTo" />
        <date-interval name="Дата следующего шага" :valueFrom.sync="filter.nextStepDateFrom" :valueTo.sync="filter.nextStepDateTo"/>
        <date-interval name="Планируемая дата" :valueFrom.sync="filter.plannedDateFrom" :valueTo.sync="filter.plannedDateTo"/>
        <date-interval name="Цель достигнута" :valueFrom.sync="filter.achievedDateFrom" :valueTo.sync="filter.achievedDateTo"/>

        <user-autocomplete-multiple name="Клиенты" :select.sync="filter.usersClientSelected"/>
        <user-autocomplete-multiple name="Специалисты" _type="spec" :select.sync="filter.usersSpecSelected"/>

        <label-view title="Статус">
          <template v-slot:content>
            <v-list class="pa-0" nav>
              <v-list-item
                  v-for="key in Object.keys(statuses)" :key="key"
                  @click="filter.statusesSelected.filter((v)=>v===key).length===0 ? filter.statusesSelected.push(key) : filter.statusesSelected = filter.statusesSelected.filter((v)=>v!==key);"
                  class="mb-0"
              >
                <v-checkbox :input-value="isCheckboxChecked(key)" :value="filter.statusesSelected.filter((v)=>v===key).length>0" class="mb-2" color="primary" dense hide-details="auto" />
                <div>
                  <v-icon size="18" :color="statuses[key].color" class="mr-2">{{ statuses[key].icon }}</v-icon>
                  {{ statuses[key].name }}
                </div>
              </v-list-item>
            </v-list>
          </template>
        </label-view>

        <direction-autocomplete-multiple :select.sync="filter.selectedDirections" :directionCatId="13" class="mb-4 mt-1"/>

        <checkbox-field class="mb-4" name="Есть просроченные услуги" :value.sync="filter.isOverDate"/>

        <checkbox-field class="mb-4" name="Без направления" :value.sync="filter.emptyDirections"/>

        <tag-autocomplete-multiple :select.sync="filter.tags" entityType="medPlan"/>
          
        <date-interval name="Интервал действия тега" :valueFrom.sync="filter.tagStartDate" :valueTo.sync="filter.tagEndDate " />

        <v-btn class="my-3" small block depressed color="silver" @click="filterReset">
          Очистить фильтр
        </v-btn>
      </div>
    </template>
    <template v-slot:content="{height}">
      <n-table-view
        :genRequestBuilder="genRequestBuilder"
        :height="height"
        :headers.sync="headers"  
        ref="table"
        settingsKey="medPlansTableSettings"
        name="Мед.планы"
      >
      <template v-slot:item="{ item }">
          <tr @click="medPlanId=parseInt(item.id)" :style="item.isOverDate ? {background:'#FFEBEE'}: ''" :title="item.isOverDate ?'В медплане есть просроченные услуги': null">
            <template v-for="header in headers">
              
              <td class="text-wrap" v-if="header.value === 'id'&&header.visible" :key="'td_'+header.value">{{ item.id }}</td>
              
              <td v-if="header.value === 'name'&&header.visible" :key="'td_'+header.value">
                <div class="d-flex align-center">
                  <v-icon v-if="item.isOverDate" class="mr-2" color="red" small>mdi-alert-circle</v-icon> 
                  <span>{{$tools.isEmpty(item.name) ? 'Без названия' : item.name}}</span>
                </div>
              </td>

              <td v-if="header.value === 'user.lastName'&&header.visible" :key="'td_'+header.value" :data-print="$tools.userFullName(item.user)">
                <UserFullName :user="item.user" short/>
              </td>

              <td v-if="header.value === 'user.userProfile.birth'&&header.visible" :key="'td_'+header.value" :data-print="$tools.date(item.user.userProfile.birth)">{{ $tools.date(item.user.userProfile.birth) }}</td>

              <td v-if="header.value === 'userSpec.lastName'&&header.visible" :key="'td_'+header.value" :data-print="$tools.userFullName(item.userSpec)">
                <UserFullName  v-if="item.userSpec" :user="item.userSpec" type="spec" short/>
                <span v-else>-</span>  
              </td>

              <td v-if="header.value === 'user.phone'&&header.visible" :key="'td_'+header.value" :data-print="item.user.phone">
                <call-phone :phone="item.user.phone" />
              </td>
  
              <td v-if="header.value === 'begin'&&header.visible" :key="'td_'+header.value" class="text-no-wrap">
                {{item.begin===null ? '-' : $tools.date(item.begin)}}
              </td>

              <td v-if="header.value === 'plannedDate'&&header.visible" :key="'td_'+header.value" class="text-no-wrap">
                {{item.plannedDate===null ? '-' : $tools.date(item.plannedDate)}}
              </td>

              <td v-if="header.value === 'nextStepDate'&&header.visible" :key="'td_'+header.value" class="text-no-wrap">
                {{item.nextStepDate===null ? '-' : $tools.date(item.nextStepDate)}}
              </td>

              <td v-if="header.value === 'achievedDate'&&header.visible" :key="'td_'+header.value" class="text-no-wrap">
                {{item.achievedDate===null ? '-' : $tools.date(item.achievedDate)}}
              </td>

              <td v-if="header.value === 'commment'&&header.visible" :key="'td_'+header.value">
                {{$tools.isEmpty(item.comment) ? '-' : item.comment}}
              </td>


              <td v-if="header.value === 'status'&&header.visible" :key="'td_'+header.value" class="text-center" :data-print="item.status==='active' ? 'активен' : item.status==='done' ? 'выполнен' :  item.status==='achieved' ? 'цель достигнута' : 'завершен' ">
                <tooltip v-if="item.status === 'active'" right>              
                  <v-icon class="mr-2" size="18" color="primary" style="margin-top:-1px">mdi-checkbox-blank-circle-outline</v-icon>
                  <template v-slot:content>
                    Активен
                  </template>
                </tooltip>

                <tooltip v-else-if="item.status === 'achieved'" right>              
                  <v-icon class="mr-2" size="18" color="purple" style="margin-top:-1px">mdi-checkbox-marked-circle-auto-outline</v-icon>
                  <template v-slot:content>
                    Цель достигнута
                  </template>
                </tooltip>

                <tooltip v-else-if="item.status === 'done'" right>              
                  <v-icon class="mr-2" size="18" color="warning" style="margin-top:-1px">mdi-check-all</v-icon>
                  <template v-slot:content>
                    Выполнен
                  </template>
                </tooltip>

                <tooltip v-else right>              
                  <v-icon class="mr-2" size="18" color="success" style="margin-top:-1px">mdi-check-decagram</v-icon>
                  <template v-slot:content>
                    Завершен
                  </template>
                </tooltip>
              </td>

              <td v-if="header.value === 'payStatus'&&header.visible" :key="'td_'+header.value" class="text-no-wrap">
                <v-chip v-if="item.summary.wait===0" class="status d-block text-center" small color="success">Оплачено</v-chip>
                <v-chip v-else class="status d-block text-center" small color="warning">Не оплачено</v-chip>
              </td>

              <td v-if="header.value === 'item.user.accountBalance'&&header.visible" :key="'td_'+header.value" class="text-no-wrap" :data-print="item.summary.total">
                {{$tools.price(item.user.accountBalance, '-')}}
              </td>

              <td v-if="header.value === 'item.summary.total'&&header.visible" :key="'td_'+header.value" class="text-no-wrap" :data-print="item.summary.total">
                {{$tools.price(item.summary.total, '-')}}
              </td>

              <td v-if="header.value === 'item.summary.cancel'&&header.visible" :key="'td_'+header.value" class="text-no-wrap" :data-print="item.summary.cancel">
                {{$tools.price(item.summary.cancel, '-')}}
              </td>

              <td v-if="header.value === 'item.summary.success'&&header.visible" :key="'td_'+header.value" class="text-no-wrap" :data-print="item.summary.success">
                {{$tools.price(item.summary.success, '-')}}
              </td>

              <td v-if="header.value === 'item.summary.wait'&&header.visible" :key="'td_'+header.value" class="text-no-wrap" :data-print="item.summary.wait">
                {{$tools.price(item.summary.wait, '-')}}
              </td>
              
              <td v-if="header.value === 'directions.name'&&header.visible" :key="'td_'+header.value">
                {{directionNames(item.directions)}}
              </td>

              <td v-if="header.value === 'tagLink.name'&&header.visible" :key="'td_'+header.value" class="text-no-wrap">
                <template v-for="v in item.tagLinks">
                  <chip v-if="v.status==='active'" :key="'tag_'+v.id" class="mr-2" :color="v.tag.color"><span :style="`color:${$tools.getContrastColor(v.tag.color)}`">{{v.tag.name}}</span></chip>
                </template>
              </td>
            </template>
          </tr>
        </template>
      </n-table-view>
      <med-plan :medPlanId.sync="medPlanId" @reLoadTable="$refs.table.load();"/>
    </template>
  </layout-view>
</template>

<script>
import LayoutView from "@/components/LayoutView";
import NTableView from "@/componentsV2/base/NTableView.vue";
import CheckboxField from "@/componentsV2/base/CheckboxField.vue";
import LabelView from "@/components/LabelView";
import moment from "moment";
import DateInterval from "@/componentsV2/base/DateInterval.vue";
import MedPlan from "@/views/MedPlan/MedPlan";
import UserAutocompleteMultiple from "@/componentsV2/custom/UserAutocompleteMultiple.vue";
import {
  Entity_MedPlan, 
  Entity_User, 
  Entity_UserProfile,
  Entity_Direction,
  Entity_TagLink,
  Entity_Tag
} from "../../../EntityStoreCacheService";
import Tooltip from "@/componentsV2/base/Tooltip.vue";
import DirectionAutocompleteMultiple from "@/componentsV2/custom/DirectionAutocompleteMultiple.vue";
import Chip from "../../componentsV2/base/Chip.vue";
import TagAutocompleteMultiple from "../../componentsV2/custom/TagAutocompleteMultiple.vue";
import UserFullName from "@/componentsV2/custom/UserFullName.vue";
import CallPhone from "@/components/CallPhone.vue";


export default {
  components: {
    NTableView,
    LabelView, 
    LayoutView,
    MedPlan,
    DateInterval,
    CheckboxField,
    UserAutocompleteMultiple,
    Tooltip,
    DirectionAutocompleteMultiple,
    Chip,
    TagAutocompleteMultiple,
    UserFullName,
    CallPhone
  },
  props: ['userSpecDesktop'],
  data:()=>({
    filter:{},
    baseFilter:{
      dateFrom:null,
      dateTo:null,
      plannedDateFrom: null,
      plannedDateTo: null,
      nextStepDateFrom: null,
      nextStepDateTo: null,
      achievedDateFrom: null,
      achievedDateTo: null,
      statusesSelected:[],
      usersClientSelected:[],
      usersSpecSelected:[],
      isOverDate:false,
      emptyDirections: false,
      selectedDirections: [],
      tags:[],
      tagStartDate: null,
      tagEndDate: null,
    },
    filterStorageKey: 'medPlansFilter?v2', 
    headers: [
      { text: 'ID', value: 'id', sortable: true, width:'auto', visible: true},
      { text: 'Название', class:'text-no-wrap', value: 'name', sortable: true, width:400, visible: true },
      { text: 'Клиент', class:'text-no-wrap', value: 'user.lastName', sortable: true, width:200, visible: true},
      { text: 'Телефон', class:'text-no-wrap', value: 'user.phone', sortable: true, visible: true},
      { text: 'Дата рождения', value: 'user.userProfile.birth', class:'text-no-wrap', visible: true},
      { text: 'Специалист', class:'text-no-wrap', value: 'userSpec.lastName', sortable: true, width:200, visible: true},
      { text: 'Назначен', class:'text-no-wrap', value:'begin', sortable: true, visible: true},
      { text: 'План', class:'text-no-wrap', value:'plannedDate', sortable: true, visible: true},
      { text: 'Следующий шаг', class:'text-no-wrap', value:'nextStepDate', sortable: true, visible: true},
      { text: 'Цель', class:'text-no-wrap', value:'achievedDate', sortable: true, visible: true},
      { text: 'Комментарий', class:'text-no-wrap', value:'commment',  sortable: false, width:200, visible: true},
      { text: 'Статус', class:'text-no-wrap', value:'status', sortable: true, visible: true},
      { text: 'Статус оплаты', class:'text-no-wrap', value:'payStatus', sortable: false, visible: true},
      { text: 'Личный счёт', class:'text-no-wrap', value:'item.user.accountBalance', sortable: false, visible: true},
      { text: 'Начислено', class:'text-no-wrap', value:'item.summary.total', sortable: false, visible: true},
      { text: 'Отменено', class:'text-no-wrap', value:'item.summary.cancel', sortable: false, visible: true},
      { text: 'Оплачено', class:'text-no-wrap', value:'item.summary.success', sortable: false, visible: true},
      { text: 'Осталось', class:'text-no-wrap', value:'item.summary.wait', sortable: false, visible: true},
      { text: 'Направление', class:'text-no-wrap', value: 'directions.name', sortable: false, width:200, visible: true},
      { text: 'Теги', class:'text-no-wrap', value: 'tagLink.name', sortable: false, width:200, visible: true},
    ],
    medPlanId:null,
    statuses:{
      'active':{'name':'Активен', 'color': 'primary', 'icon': "mdi-checkbox-blank-circle-outline"},
      'achieved':{'name':'Цель достигнута', 'color': 'purple', 'icon': "mdi-checkbox-marked-circle-auto-outline"},
      'done':{'name':'Выполнен', 'color': 'warning', 'icon': "mdi-check-all"},
      'complete':{'name':'Завершён', 'color': 'success', 'icon': 'mdi-check-decagram'}},
  }),
  mounted(){
    // фильтр из localStorage
    this.filter = this.$tools.storageGet(this.filterStorageKey, this.$tools.copy(this.baseFilter))

    if (this.userSpecDesktop !== undefined){
      this.filter.usersSpecSelected = [];
      if (this.userSpecDesktop) {
          this.filter.usersSpecSelected.push(this.userSpecDesktop); 
      } else {
        new Entity_User()
        .selects(Entity_User.id)
        .selects(Entity_User.firstName)
        .selects(Entity_User.lastName)
        .selects(Entity_User.secondName)
        .selects(Entity_User.type)
        .selects([Entity_User.userProfile,Entity_UserProfile.gender].join('.'))
        .selects([Entity_User.userProfile,Entity_UserProfile.birth].join('.'))
        .filterAnd([Entity_User.entity,Entity_User.id].join('.')+'=?',parseInt(this.$store.state.user.id))
        .request((r)=>{
          this.filter.usersSpecSelected = r.items;
          this.$refs.table.load();
        }, (e)=>{
          console.error(e.response.data.message);
        })
      }
    }
  },
  computed: {
    directionNames() {
      return (items) => {
        if (items.length>0) {
          let directions = [];
          items.forEach(i => {
            directions.push(i.name);
          });
          return `${directions.join()}`;
        } else return '-';
      }
    },
  },
  watch:{
    filter: {
      handler() {
        //сохраняем фильтры в localStorage
        this.$tools.storageSet(this.filterStorageKey, this.filter);
        this.$refs.table.load();
      },
      deep: true,
    },
  },
  methods:{
    genRequestBuilder(page, onPage, sortFields){
      let rb = new Entity_MedPlan()
        .selects(Entity_MedPlan.id)
        .selects(Entity_MedPlan.name)
        .selects(Entity_MedPlan.begin)
        .selects(Entity_MedPlan.end)
        .selects(Entity_MedPlan.plannedDate)
        .selects(Entity_MedPlan.achievedDate)
        .selects(Entity_MedPlan.nextStepDate)
        .selects(Entity_MedPlan.comment)
        .selects(Entity_MedPlan.status)
        //user
        .selects([Entity_MedPlan.user,Entity_User.id].join('.'))
        .selects([Entity_MedPlan.user,Entity_User.firstName].join('.'))
        .selects([Entity_MedPlan.user,Entity_User.lastName].join('.'))
        .selects([Entity_MedPlan.user,Entity_User.secondName].join('.'))
        .selects([Entity_MedPlan.user,Entity_User.userProfile, Entity_UserProfile.birth].join('.'))
        .selects([Entity_MedPlan.user,Entity_User.phone].join('.'))
        
        //userSpec
        .selects([Entity_MedPlan.userSpec,Entity_User.id].join('.'))
        .selects([Entity_MedPlan.userSpec,Entity_User.firstName].join('.'))
        .selects([Entity_MedPlan.userSpec,Entity_User.lastName].join('.'))
        .selects([Entity_MedPlan.userSpec,Entity_User.secondName].join('.'))

        //directions
        .selects([Entity_MedPlan.directions, Entity_Direction.name].join('.'))

        //tagLinks
        .selects([Entity_User.tagLinks, Entity_TagLink.id].join('.'))
        .selects([Entity_MedPlan.tagLinks, Entity_TagLink.status].join('.'))
        .selects([Entity_MedPlan.tagLinks, Entity_TagLink.tag, Entity_Tag.name].join('.'))
        .selects([Entity_MedPlan.tagLinks, Entity_TagLink.tag, Entity_Tag.color].join('.'))
        
        //virtual
        .virtual(Entity_MedPlan.virtual_isOverDate)
        .virtual(Entity_MedPlan.virtual_summary);
        


        rb.page(page).onPage(onPage)

        // date
        if(this.filter.dateFrom)  
          rb.filterAnd([Entity_MedPlan.entity, Entity_MedPlan.begin].join('.')+'>=?',moment(this.filter.dateFrom, 'DD-MM-YYYY').format('YYYY-MM-DD 00:00:00')); 

        if(this.filter.dateTo) 
          rb.filterAnd([Entity_MedPlan.entity, Entity_MedPlan.begin].join('.')+'<=?',moment(this.filter.dateTo, 'DD-MM-YYYY').format('YYYY-MM-DD 23:59:59'));       

        // nextStepDate
        if(this.filter.nextStepDateFrom)
          rb.filterAnd([Entity_MedPlan.entity, Entity_MedPlan.nextStepDate].join('.')+'>=?',moment(this.filter.nextStepDateFrom, 'DD-MM-YYYY').format('YYYY-MM-DD 00:00:00'));       

        if(this.filter.nextStepDateTo)  
          rb.filterAnd([Entity_MedPlan.entity, Entity_MedPlan.nextStepDate].join('.')+'<=?',moment(this.filter.nextStepDateTo, 'DD-MM-YYYY').format('YYYY-MM-DD 23:59:59'));
   
        // plannedDate
        if(this.filter.plannedDateFrom)
          rb.filterAnd([Entity_MedPlan.entity, Entity_MedPlan.plannedDate].join('.')+'>=?',moment(this.filter.plannedDateFrom, 'DD-MM-YYYY').format('YYYY-MM-DD 00:00:00'));
        
        if(this.filter.plannedDateTo)  
          rb.filterAnd([Entity_MedPlan.entity, Entity_MedPlan.plannedDate].join('.')+'<=?',moment(this.filter.plannedDateTo, 'DD-MM-YYYY').format('YYYY-MM-DD 23:59:59'));

        // achievedDate
        if(this.filter.achievedDateFrom)
          rb.filterAnd([Entity_MedPlan.entity, Entity_MedPlan.achievedDate].join('.')+'>=?',moment(this.filter.achievedDateFrom, 'DD-MM-YYYY').format('YYYY-MM-DD 00:00:00'));
        
        if(this.filter.achievedDateTo)  
          rb.filterAnd([Entity_MedPlan.entity, Entity_MedPlan.achievedDate].join('.')+'<=?',moment(this.filter.achievedDateTo, 'DD-MM-YYYY').format('YYYY-MM-DD 23:59:59'));
        
        if (this.filter.statusesSelected.length>0)
          rb.filterAnd([Entity_MedPlan.entity, Entity_MedPlan.status].join('.')+' in (?)',this.filter.statusesSelected);
        
        if (this.filter.usersClientSelected.length>0)
          rb.filterAnd([Entity_MedPlan.entity, Entity_User.entity, Entity_User.id].join('.')+' in (?)', this.filter.usersClientSelected.map(i=>i.id))

        if (this.filter.usersSpecSelected.length>0)
          rb.filterAnd([Entity_MedPlan.entity, Entity_MedPlan.userSpec, Entity_User.id].join('.')+' in (?)',  this.filter.usersSpecSelected.map(i=>i.id))

        if (this.filter.isOverDate)
          rb.filterAdd(['overDate'].join('.'));

        if (this.filter.selectedDirections.length>0)
          rb.filterAnd([Entity_MedPlan.entity, Entity_MedPlan.directions, Entity_Direction.id].join('.')+' in (?)', this.filter.selectedDirections.map(i=>i.id))

        if (this.filter.emptyDirections)
          rb.filterAnd([Entity_MedPlan.entity, Entity_MedPlan.directions, Entity_Direction.id].join('.')+' is null');

        if(!this.$tools.isEmpty(this.filter.tags)){
          rb.filterAnd([
            Entity_MedPlan.entity, Entity_MedPlan.tagLinks,
            Entity_TagLink.tag, Entity_Tag.id
          ].join('.') + ' IN (?)', this.filter.tags.map(v=>v.id))


          if (this.filter.tagStartDate&&this.filter.tagEndDate){
              rb.filterAnd(
              [Entity_MedPlan.entity, Entity_MedPlan.tagLinks, Entity_TagLink.startDate].join('.')+' <=? AND '+
              [Entity_MedPlan.entity, Entity_MedPlan.tagLinks, Entity_TagLink.endDate].join('.')+' >=?'
              ,moment(this.filter.tagEndDate, 'DD-MM-YYYY').format('YYYY-MM-DD 23:59:59')
              ,moment(this.filter.tagStartDate, 'DD-MM-YYYY').format('YYYY-MM-DD 00:00:00')
             );
          } else if(this.filter.tagStartDate&&!this.filter.tagEndDate){
            rb.filterAnd(
              [Entity_MedPlan.entity, Entity_MedPlan.tagLinks, Entity_TagLink.startDate].join('.')+'>=? OR '+
              [Entity_MedPlan.entity, Entity_MedPlan.tagLinks, Entity_TagLink.endDate].join('.')+' >=?'
              ,moment(this.filter.tagStartDate, 'DD-MM-YYYY').format('YYYY-MM-DD 00:00:00')
              ,moment(this.filter.tagStartDate, 'DD-MM-YYYY').format('YYYY-MM-DD 00:00:00')
            );
          } else if(!this.filter.tagStartDate&&this.filter.tagEndDate) {
            rb.filterAnd(
              [Entity_MedPlan.entity, Entity_MedPlan.tagLinks, Entity_TagLink.startDate].join('.')+'<=? OR '+
              [Entity_MedPlan.entity, Entity_MedPlan.tagLinks, Entity_TagLink.endDate].join('.')+' <=?'
              ,moment(this.filter.tagEndDate, 'DD-MM-YYYY').format('YYYY-MM-DD 23:59:59')
              ,moment(this.filter.tagEndDate, 'DD-MM-YYYY').format('YYYY-MM-DD 23:59:59')
            );
          } 

        }   
          
        sortFields.forEach(v=>{
          rb.order(v.field, v.isAsc)
        })

        return rb;
    },
    isCheckboxChecked(key) {
      if (this.filter.statusesSelected.includes(key)) {
        return true;
      } else {
        return false;
      }
    },
    filterReset() {
      this.filter = this.$tools.copy(this.baseFilter)
    },
  }
}
</script>